module.exports = __webpack_public_path__ + "img/4.333b09d.svg";